import { IUserProfileClientInfo } from '../../types/userProfile';

/**
 * Есть ли в профиле реальный контент для вкладки «О клиенте».
 * Ручка может ответить успехом, но с пустым (или полностью незаполненным) профилем,
 * поэтому «успешный ответ» и «есть данные» — это разные вещи.
 */
export const hasClientInfoContent = (clientInfo: IUserProfileClientInfo | null | undefined): boolean => {
  return Boolean(
    clientInfo?.searchInfo?.tags.length ||
    clientInfo?.statistics?.parameters.length ||
    clientInfo?.recentlyWatchedOffers?.offers.length ||
    clientInfo?.promo?.features.length,
  );
};
